// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-hot-toast";
// import FileUpload from "../../components/common/FileUpload";
// import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
// import Loader from "../../components/common/Loader";
// import Badge from '@mui/material/Badge';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPlus, faMagnifyingGlass, faTrash } from '@fortawesome/free-solid-svg-icons';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
// import Button from '@mui/material/Button';
// import { green, yellow, red, deepPurple } from '@mui/material/colors';
// import { SERVER_ORIGIN } from "../../utilities/constants";
// import { hasReadOnlyAccess, getDashboardPath } from "../../utilities/helper_functions";
// import HeaderCard from "../../components/common/HeaderCard";
// import BackButton from "../../components/common/BackButton";
// // import { refreshScreen } from "../../utilities/helper_functions";

// import css from "../../css/admin/users-page.module.css";
// import DownloadExcel from "../../components/common/DownloadExcel";

// // localhost:800/users/all?page=1&limit=10&search=abhishek&sortBy=fName&sortType=desc


// const AdminInstitutes = () => {
//     const [isLoading, setIsLoading] = useState(false);
//     const [limit, setLimit] = useState(0);
//     const [allInstitutes, setAllInstitutes] = useState([]);
//     const [page, setPage] = useState(1);
//     const [sortType, setSortType] = useState(true);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [mouStatus, setMouStatus] = useState("");
//     const [totalPages, setTotalPages] = useState(0);
//     // const [rerender, setRerender] = useState(true);
//     const navigate = useNavigate();

//     // Check if user has read-only access
//     const isReadOnly = hasReadOnlyAccess();

//     useEffect(() => {
//         async function getAllChapters() {
//             setIsLoading(true);

//             try {
//                 // const adminId = process.env.REACT_APP_ADMIN_ID;
//                 // const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;
//                 // const basicAuth = btoa(`${adminId}:${adminPassword}`);
//                 const response = await fetch(
//                     `${SERVER_ORIGIN}/api/chapter/auth/get-all?page=${page}&limit=${limit}&search=${searchQuery}&sortBy=name&sortType=${sortType === true ? "asc" : "desc"
//                     }`,
//                     {
//                         method: "GET",
//                         headers: {
//                             "Content-Type": "application/json",
//                             //Authorization: `Basic ${basicAuth}`, // Include Basic Authentication
//                             "auth-token": sessionStorage.getItem("token"),
//                         },
//                     }
//                 );

//                 const result = await response.json();
//                 // console.log(result)
//                 setIsLoading(false);
//                 if (response.status >= 400 && response.status < 600) {
//                     if (response.status === 401) {
//                         navigate("/admin/login");
//                     } else if (response.status === 500) {
//                         toast.error(result.statusText);
//                     }
//                 } else if (response.status === 200) {
//                     setAllInstitutes(result.filteredChapters);
//                     setTotalPages(result.totalPages);
//                     // setMouStatus(result.filteredChapters)
//                     // console.log(mouStatus, "setIsLoading")
//                 } else {
//                     // for future
//                 }
//             } catch (err) {
//                 setIsLoading(false);
//             }
//         }
//         getAllChapters();
//     }, [page, sortType, searchQuery, navigate]);
//     const renderOnboardingStatus = (params) => {
//         let statusColor;
//         let statusText;
//         let textColor;

//         switch (params.value) {
//             case 'invited':
//                 statusColor = yellow[500];
//                 statusText = 'Invited';
//                 textColor = "black";
//                 break;
//             case 'pending':
//                 statusColor = deepPurple[500];
//                 statusText = 'Pending';
//                 textColor = "white";
//                 break;
//             case 'onboarded':
//                 statusColor = green[500];
//                 statusText = 'Onboarded';
//                 textColor = "white";
//                 break;
//             case 'approved':
//                 statusColor = green[500];
//                 statusText = 'Onboarded';
//                 textColor = "white";
//                 break;
//             case 'rejected':
//                 statusColor = red[500];
//                 statusText = 'Onboarded';
//                 textColor = "white";
//                 break;
//             case 'submitted':
//                 statusColor = yellow[500];
//                 statusText = 'Submitted';
//                 textColor = "black";
//                 break;
//             default:
//                 statusColor = 'black';
//                 statusText = 'Unknown';
//                 textColor = "white";
//         }
//         return <Badge>
//             <span style={{ backgroundColor: statusColor, padding: '6.4px 16px', borderRadius: '8px', color: textColor }}>
//                 {statusText}
//             </span>
//         </Badge>
//     }
//     const renderEmailStatus = (params) => {
//         let statusColor;
//         let statusText;
//         let textColor;

//         switch (params.value) {
//             case 'sent':
//                 statusColor = green[500];
//                 statusText = 'Sent';
//                 textColor = "white";
//                 break;
//             case 'not sent':
//                 statusColor = red[500];
//                 statusText = 'Not Sent';
//                 textColor = "white";
//                 break;
//             default:
//                 statusColor = 'black';
//                 statusText = 'Unknown';
//                 textColor = "white";
//         }
//         return <Badge >
//             <span style={{ borderRadius: '8px', backgroundColor: statusColor, padding: '6.4px 16px', color: textColor }}>
//                 {statusText}
//             </span>
//         </Badge>
//     }
//     const handelChapterRemove = async (_id) => {
//         try {
//             const response = await fetch(`${SERVER_ORIGIN}/api/chapter/auth/dlt/${_id}`, {
//                 method: 'POST',
//                 headers: {
//                     'auth-token': sessionStorage.getItem('token'),
//                     'Content-Type': 'application/json',
//                 },
//             });
//             const result = await response.json();
//             if (response.status >= 300) {
//                 toast.error(result.statusText);
//             } else {
//                 toast.success(result.statusText);
//             }
//             setTimeout(() => {
//                 window.location.reload();
//             }, 1000);
//         } catch (error) {
//             toast.error(error.message);
//         } finally {

//         }
//     }

//     const rows = allInstitutes.map((institute, idx) => ({ ...institute, 'id': idx + 1 }))
//     // let rowIndexCounter = 0;
//     const columns = [
//         {
//             field: 'id',
//             headerName: 'ID',
//             width: 90,
//             // renderCell: (params) => params.id++

//         },
//         {
//             field: 'chapter_name',
//             headerName: 'Chapter Name',
//             width: 170,
//             // editable: true,
//         },
//         {
//             field: 'region',
//             headerName: 'Region Name',
//             width: 150,
//             // editable: true,
//         },
//         {
//             field: 'country',
//             headerName: 'Country',
//             width: 150,
//             // editable: true,
//         },
//         {
//             field: 'state',
//             headerName: 'State',
//             width: 150,
//             // editable: true,
//         },
//         {
//             field: 'city',
//             headerName: 'City',
//             width: 150,
//             // editable: true,
//         },
//         {
//             field: 'editDetails',
//             headerName: 'Edit',
//             type: 'actions',
//             width: 150,
//             align: 'center',
//             renderCell: (params) => (
//                 <button
//                     className={css.viewBtn}
//                     onClick={() =>
//                         navigate(
//                             `/admin/chapter/insert?edit=true&id=${encodeURIComponent(params.row._id)}`
//                         )
//                     }
//                 >
//                     Edit
//                 </button>
//             )
//         },
//         ...(isReadOnly ? [] : [{
//             headerName: 'Action',
//             type: 'button',
//             width: 200,
//             renderCell: (params) => {
//                 const { row: { _id } } = params;
//                 const handleRemoveClick = () => {
//                     setOpenDialog(true);
//                     setSelectedId(_id);
//                 };
//                 return (
//                     <div onClick={handleRemoveClick}>
//                         <FontAwesomeIcon icon={faTrash} style={{ color: "red", marginRight: "5px", cursor: "pointer" }} />
//                     </div>
//                 );
//             }
//         }])
//     ];
//     // console.log(allInstitutes)


//     function handleChapterClick() {
//         navigate("/admin/chapter/insert");
//     }



//     function CustomColumnMenu(props) {
//         return (
//             <GridColumnMenu
//                 {...props}
//                 slots={{
//                     // Add item
//                     // columnMenuUserItem: CustomUserItem,
//                 }}
//                 slotProps={{
//                     columnMenuUserItem: {
//                         // set `displayOrder` for new item
//                         displayOrder: 15,
//                         // pass additional props
//                         myCustomValue: 'Do custom action',
//                         myCustomHandler: () => alert('Custom handler fired'),
//                     },
//                 }}
//             />
//         );
//     }
//     const [openDialog, setOpenDialog] = useState(false);
//     const [selectedId, setSelectedId] = useState(null);

//     const handleDialogClose = () => {
//         setOpenDialog(false);
//     };

//     const handleDeleteConfirm = async (id) => {
//         await handelChapterRemove(id);
//         setOpenDialog(false);
//     };

//     return (
//         <div className={css.outerDiv}>
//             <HeaderCard>
//                 <BackButton text="Back to Dashboard" customPath={getDashboardPath()} />
//                 <h1 className="headerTitle">Chapters</h1>

//                 <hr />
//                 {isReadOnly ? (
//                     <div>
//                         <p className="headerSubtitle">
//                             You have read-only access to view chapter data.
//                         </p>
//                         <div className="alert alert-info" role="alert">
//                             <strong>Note:</strong> As a Region EM user, you can view all chapter data but cannot add, edit, or delete any records.
//                         </div>
//                     </div>
//                 ) : (
//                     <div>
//                         <p className="headerSubtitle">
//                             You can view the chapter list.
//                         </p>
//                         <p className="headerSubtitle">
//                             Note: No change can be done once added.
//                         </p>

//                         <div className='d-flex justify-content-evenly align-items-baseline mt-3'>

//                             <div >
//                                 <button
//                                     className={`${css.fileUploadBtn} commonBtn`}
//                                     onClick={handleChapterClick}
//                                 >
//                                     <FontAwesomeIcon icon={faPlus} style={{ color: "#ffffff", marginRight: "5px" }} /> Add Chapter
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//             </HeaderCard>
//             <div className={css.filterBtns}>

//                 <div className={css.searchInputs}>
//                     <div className='d-flex' style={{ position: 'relative', justifyContent: 'end', alignItems: 'center' }}>
//                         <input
//                             type="text"
//                             value={searchQuery}
//                             placeholder="Search from chapter list"
//                             onChange={(e) => {
//                                 setSearchQuery(e.target.value);
//                                 // setPage(1);
//                             }}
//                             className={css.searchInput}
//                         />
//                         <FontAwesomeIcon icon={faMagnifyingGlass} style={{ color: "black", position: 'absolute', right: '10px' }} />
//                     </div>
//                 </div>
//             </div>
//             {isLoading ? (
//                 <Loader />
//             ) : (
//                 <div>
//                     <DataGrid
//                         rows={rows}
//                         columns={columns}
//                         initialState={{
//                             pagination: {
//                                 paginationModel: { pageSize: 7, page: 0 },
//                             },
//                         }}
//                         slots={{ columnMenu: CustomColumnMenu }}
//                     // checkboxSelection
//                     // disableRowSelectionOnClick
//                     />
//                     <Dialog
//                         open={openDialog}
//                         onClose={handleDialogClose}
//                         aria-labelledby="alert-dialog-title"
//                         aria-describedby="alert-dialog-description"
//                     >
//                         <DialogTitle id="alert-dialog-title">Delete</DialogTitle>
//                         <DialogContent>
//                             <DialogContentText id="alert-dialog-description">
//                                 Are you sure, you want to delete this record?
//                             </DialogContentText>
//                         </DialogContent>
//                         <DialogActions>
//                             <Button onClick={() => handleDeleteConfirm(selectedId)}>Yes</Button>
//                             <Button onClick={handleDialogClose}>No</Button>
//                         </DialogActions>
//                     </Dialog>

//                 </div>
//             )}
//         </div>
//     );
// };

// export default AdminInstitutes;


import {
  faDownload,
  faEllipsisVertical,
  faMagnifyingGlass,
  faPlus,
  faTrash,
  faUpload
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { DataGrid, GridColumnMenu, GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import BackButton from "../../components/common/BackButton";
import Loader from "../../components/common/Loader";
import SecCard from "../../components/common/SecCard";
import { SERVER_ORIGIN } from "../../utilities/constants";
import {
  getDashboardPath,
  hasReadOnlyAccess,
} from "../../utilities/helper_functions";
// import StatCard from "../../components/common/StatCard";

import css from "../../css/admin/users-page.module.css";

const AdminInstitutes = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [limit, setLimit] = useState(0);
  const [allInstitutes, setAllInstitutes] = useState([]);
  const [page, setPage] = useState(1);
  const [sortType, setSortType] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const navigate = useNavigate();

  // Check if user has read-only access
  const isReadOnly = hasReadOnlyAccess();

  console.log("isReadOnly:", isReadOnly);
  const currentUserType = sessionStorage.getItem("userType");
  const userRegion = sessionStorage.getItem("region");

  console.log("currentUserType:", currentUserType);
  console.log("userRegion:", userRegion);

  // State for filters
  const [filters, setFilters] = useState({
    region: "",
    state: "",
    city: "",
  });

  // Get unique values for dropdowns
  const uniqueRegions = [
    ...new Set(allInstitutes.map((item) => item.region).filter(Boolean)),
  ];
  const uniqueStates = [
    ...new Set(allInstitutes.map((item) => item.state).filter(Boolean)),
  ];
  const uniqueCities = [
    ...new Set(allInstitutes.map((item) => item.city).filter(Boolean)),
  ];

  // Stats data
  const totalChapters = allInstitutes.length;
  const activeChapters = allInstitutes.filter(
    (chapter) => chapter.status === "active"
  ).length;
  const pendingChapters = allInstitutes.filter(
    (chapter) => chapter.status === "pending"
  ).length;

  useEffect(() => {

    async function canVisitPage() {
      setIsLoading(true);
      try {
        const currentUserType = sessionStorage.getItem("userType");

        let verifyEndpoint = "";
        let headers = {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token"),
        };

        if (currentUserType === "admin") {
          verifyEndpoint = `${SERVER_ORIGIN}/api/admin/auth/verify-token`;
          const adminId = process.env.REACT_APP_ADMIN_ID;
          const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;
          const basicAuth = btoa(`${adminId}:${adminPassword}`);
          headers.Authorization = `Basic ${basicAuth}`;
        } else if (currentUserType === "regionem") {
          verifyEndpoint = `${SERVER_ORIGIN}/api/regionem/auth/verify-token`;
        } else {
          navigate("/login");
          return;
        }

        const response = await fetch(verifyEndpoint, {
          method: "POST",
          headers: headers,
        });

        const result = await response.json();

        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            navigate(`/login?userType=${currentUserType}`);
          } else {
            toast.error(result.statusText);
          }
        }
      } catch (err) {
        console.log(err.message);
        navigate("/login");
      }
      setIsLoading(false);
    }

    async function getAllChapters() {
      setIsLoading(true);

      try {

        let regionQuery = "";

        if (currentUserType === "regionem" && userRegion) {
          regionQuery = `&region=${userRegion}`;
        }

        const response = await fetch(
          `${SERVER_ORIGIN}/api/chapter/auth/get-all?page=${page}&limit=${limit}&search=${searchQuery}&sortBy=name&sortType=${sortType === true ? "asc" : "desc"
          }${regionQuery}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem("token"),
            },
          }
        );

        const result = await response.json();
        setIsLoading(false);
        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            navigate("/admin/login");
          } else if (response.status === 500) {
            toast.error(result.statusText);
          }
        } else if (response.status === 200) {
          setAllInstitutes(result.filteredChapters);
          setTotalPages(result.totalPages);
        }
      } catch (err) {
        setIsLoading(false);
      }
    }
    getAllChapters();
    canVisitPage();
  }, [page, sortType, searchQuery, navigate, limit]);

  // Handle filter changes
  const handleFilterChange = (filterName, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  // Apply filters to data
  const filteredChapters = allInstitutes.filter((chapter) => {
    return (
      (!filters.region || chapter.region === filters.region) &&
      (!filters.state || chapter.state === filters.state) &&
      (!filters.city || chapter.city === filters.city)
    );
  });

  // Clear all filters
  const clearAllFilters = () => {
    setFilters({
      region: "",
      state: "",
      city: "",
    });
    setSearchQuery("");
  };

  const handelChapterRemove = async (_id) => {
    try {
      const response = await fetch(
        `${SERVER_ORIGIN}/api/chapter/auth/dlt/${_id}`,
        {
          method: "POST",
          headers: {
            "auth-token": sessionStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      );
      const result = await response.json();
      if (response.status >= 300) {
        toast.error(result.statusText);
      } else {
        toast.success(result.statusText);
      }
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const rows = filteredChapters.map((institute, idx) => ({
    ...institute,
    id: idx + 1,
  }));

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 90,
    },
    {
      field: "chapter_name",
      headerName: "Chapter Name",
      width: 170,
    },
    {
      field: "region",
      headerName: "Region Name",
      width: 150,
    },
    {
      field: "country",
      headerName: "Country",
      width: 150,
    },
    {
      field: "state",
      headerName: "State",
      width: 150,
    },
    {
      field: "city",
      headerName: "City",
      width: 150,
    },

    ...(isReadOnly
      ? []
      : [
        {
          field: "editDetails",
          headerName: "Edit",
          type: "actions",
          width: 150,
          align: "center",
          renderCell: (params) => (
            <button
              className={css.viewBtn}
              onClick={() =>
                navigate(
                  `/admin/chapter/insert?edit=true&id=${encodeURIComponent(
                    params.row._id
                  )}`
                )
              }
            >
              Edit
            </button>
          ),
        },
        {
          headerName: "Action",
          type: "button",
          width: 200,
          renderCell: (params) => {
            const {
              row: { _id },
            } = params;
            const handleRemoveClick = () => {
              setOpenDialog(true);
              setSelectedId(_id);
            };
            return (
              <div onClick={handleRemoveClick}>
                <FontAwesomeIcon
                  icon={faTrash}
                  style={{
                    color: "red",
                    marginRight: "5px",
                    cursor: "pointer",
                  }}
                />
              </div>
            );
          },
        },
      ]),
  ];

  function handleChapterClick() {
    navigate("/admin/chapter/insert");
  }

  function CustomColumnMenu(props) {
    return (
      <GridColumnMenu
        {...props}
        slotProps={{
          columnMenuUserItem: {
            displayOrder: 15,
            myCustomValue: "Do custom action",
            myCustomHandler: () => alert("Custom handler fired"),
          },
        }}
      />
    );
  }

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDeleteConfirm = async (id) => {
    await handelChapterRemove(id);
    setOpenDialog(false);
  };

  // Actions Dropdown Component
  const ActionsDropdown = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => setIsOpen(!isOpen);

    return (
      <div className={css.dropdownContainer}>
        <button
          className={css.ellipsisBtn}
          onClick={toggleDropdown}
          aria-label="More actions"
        >
          <FontAwesomeIcon icon={faEllipsisVertical} />
        </button>

        {isOpen && (
          <div className={css.dropdownMenu}>
            <button className={css.dropdownItem}>
              <FontAwesomeIcon icon={faDownload} className={css.dropdownIcon} />
              Download Excel
            </button>
            <button className={css.dropdownItem}>
              <FontAwesomeIcon icon={faUpload} className={css.dropdownIcon} />
              Upload Chapters
            </button>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={css.outerDiv}>
      {/* Header Section */}
      <div className={css.headerSection}>
        <div className={css.headerLeft}>
          <BackButton
            text="Back to Dashboard"
            customPath={getDashboardPath()}
          />
        </div>
      </div>

      {isReadOnly && (
        <div className={css.readOnlyAlert}>
          <div className="alert alert-info" role="alert">
            <strong>Read-Only Access:</strong> You can view all chapter data but
            cannot add, edit, or delete any records.
          </div>
        </div>
      )}

      {/* Main Header with Stats */}
      <div className="my-4">
        <SecCard>
          <Row className="g-4">
            <div
              className={`${css.serviceHeader} d-flex justify-content-between align-items-center mb-3`}
            >
              <div className={css.serviceName}>Chapters Data</div>

              <div className={css.headerRight}>
                {!isReadOnly && (
                  <div className={css.actionButtons}>
                    <button className={css.addBtn} onClick={handleChapterClick}>
                      <FontAwesomeIcon icon={faPlus} className={css.addIcon} />
                      Add Chapter
                    </button>

                    {/* <ActionsDropdown /> */}
                  </div>
                )}
              </div>
            </div>

          </Row>
        </SecCard>
      </div>

      {/* Search and Filters Section */}
      <div className={css.searchFiltersSection}>
        <div className={css.filtersContainer}>
          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Search</label>
            <div className={css.searchInputWrapper}>
              <input
                type="text"
                value={searchQuery}
                placeholder="Search from chapter list"
                onChange={(e) => setSearchQuery(e.target.value)}
                className={css.searchInput}
              />
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className={css.searchIcon}
              />
            </div>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Region</label>
            <select
              value={filters.region}
              onChange={(e) => handleFilterChange("region", e.target.value)}
              className={css.filterSelect}
            >
              <option value="">All Regions</option>
              {uniqueRegions.map((region) => (
                <option key={region} value={region}>
                  {region}
                </option>
              ))}
            </select>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>State</label>
            <select
              value={filters.state}
              onChange={(e) => handleFilterChange("state", e.target.value)}
              className={css.filterSelect}
            >
              <option value="">All States</option>
              {uniqueStates.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>City</label>
            <select
              value={filters.city}
              onChange={(e) => handleFilterChange("city", e.target.value)}
              className={css.filterSelect}
            >
              <option value="">All Cities</option>
              {uniqueCities.map((city) => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </select>
          </div>

          <button onClick={clearAllFilters} className={css.clearFiltersBtn}>
            Clear All
          </button>
        </div>
      </div>

      {/* Data Grid Section */}
      {isLoading ? (
        <Loader />
      ) : (
        <div className={css.dataGridContainer}>
          <DataGrid
            rows={rows}
            columns={columns}
            autoHeight
            density="compact"
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            disableRowSelectionOnClick
            sx={{
              borderRadius: 2,
              border: "1px solid #e5e7eb",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f9fafb",
                color: "#111827",
                fontWeight: 600,
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                backgroundColor: "#fcfcfd",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#eef2ff",
              },
            }}
            slots={{ columnMenu: CustomColumnMenu, toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 300 },
              },
            }}
            loading={isLoading}
          />
          <Dialog
            open={openDialog}
            onClose={handleDialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Delete</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure, you want to delete this record?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => handleDeleteConfirm(selectedId)}>
                Yes
              </Button>
              <Button onClick={handleDialogClose}>No</Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </div>
  );
};

export default AdminInstitutes;
